const ensureLeadingSlash = (value: string) => {
  if (!value) {
    return '';
  }

  return value.startsWith('/') ? value : `/${value}`;
};

const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const resolveEnvPath = (value?: string) => {
  if (!value || value === '.') {
    return '';
  }

  return ensureLeadingSlash(stripTrailingSlash(value));
};

const deriveBaseFromPublicUrl = () => {
  const publicUrl = process.env.PUBLIC_URL;

  if (!publicUrl || publicUrl === '.') {
    return '';
  }

  try {
    const parsed = new URL(publicUrl, 'http://placeholder.local');
    return resolveEnvPath(parsed.pathname);
  } catch (_error) {
    return resolveEnvPath(publicUrl);
  }
};

export const BASENAME =
  resolveEnvPath(process.env.REACT_APP_BASENAME) || deriveBaseFromPublicUrl() || '/';

const normalizedPublicUrl = (() => {
  const publicUrl = process.env.PUBLIC_URL;

  if (!publicUrl || publicUrl === '.') {
    return '';
  }

  return stripTrailingSlash(publicUrl);
})();

const isExternalPath = (path: string) =>
  /^(\w+:)?\/\//.test(path) || path.startsWith('data:') || path.startsWith('blob:');

export const withBasePath = (path: string) => {
  if (!path) {
    return path;
  }

  if (isExternalPath(path)) {
    return path;
  }

  const normalizedPath = ensureLeadingSlash(path);

  return `${normalizedPublicUrl}${normalizedPath}`;
};


